import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { admin, loading } = useAuth();
  const location = useLocation();

  if (loading) return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="spinner-border text-primary"></div>
    </div>
  );

  if (!admin) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
}
